import { ISupportUpdatePayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getSupportQueries = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/report${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getSupportQueryById = async (id: string) => {
  return serviceHelper(http.get(`/admin/report/${id}`), false);
};

export const updateSupportQueryStatus = async (
  id: string,
  data: ISupportUpdatePayload
) => {
  return serviceHelper(http.patch(`/admin/report/${id}`, data), false);
};
